import React from 'react';
import { TimerTopBar } from './components/TimerTopBar';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { ProofBar } from './components/ProofBar';
import { PainSection } from './components/PainSection';
import { FeaturesSection } from './components/FeaturesSection';
import { BeforeAfterSection } from './components/BeforeAfterSection';
import { ForWhoSection } from './components/ForWhoSection';
import { ResultsSection } from './components/ResultsSection';
import { MidCTA } from './components/MidCTA';
import { TestimonialsSection } from './components/TestimonialsSection';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { AuthorSection } from './components/AuthorSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyCTA } from './components/StickyCTA';
import { PurchaseNotification } from './components/PurchaseNotification';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="min-h-screen relative" data-id="element-0">
      <PurchaseNotification data-id="element-1" />
      <TimerTopBar data-id="element-2" />
      <TopBar data-id="element-3" />
      <Hero data-id="element-4" />
      <ProofBar data-id="element-5" />
      <div className="divider" data-id="element-6" />
      <PainSection data-id="element-7" />
      <div className="divider" data-id="element-8" />
      <FeaturesSection data-id="element-9" />
      <BeforeAfterSection data-id="element-10" />
      <ForWhoSection data-id="element-11" />
      <ResultsSection data-id="element-12" />
      <MidCTA data-id="element-13" />
      <TestimonialsSection data-id="element-14" />
      <BonusesSection data-id="element-15" />
      <div className="divider" data-id="element-16" />
      <OfferSection data-id="element-17" />
      <GuaranteeSection data-id="element-18" />
      <AuthorSection data-id="element-19" />
      <FAQSection data-id="element-20" />
      <FinalCTA data-id="element-21" />
      <Footer data-id="element-22" />
      <StickyCTA data-id="element-23" />
    </div>;
}